import { render, staticRenderFns } from "./add-register-polite.vue?vue&type=template&id=26788780&scoped=true&"
import script from "./add-register-polite.vue?vue&type=script&lang=js&"
export * from "./add-register-polite.vue?vue&type=script&lang=js&"
import style0 from "./add-register-polite.vue?vue&type=style&index=0&id=26788780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26788780",
  null
  
)

export default component.exports